import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Button
} from '@goguardian/based';
import cn from 'classnames';

import {
  setProduct,
  setReferrer,
  setKey,
  setNoSalesEmail
} from '_shared/actions';
import qs from 'query-string';
import { track } from '../../../track';
const env = process.env;

import style from './style.scss';

class Signup extends React.Component {
  componentDidMount() {
    const { product } = this.props.params;
    const urlParams = qs.parse(location.search);
    const referrer = Number(urlParams.referrer);
    const noAuthKey = urlParams.key;
    const noSalesEmail = urlParams.noSalesEmail;
    const setProductRes = this.props.dispatch(setProduct(product));

    if (referrer && !isNaN(referrer)) {
      this.props.dispatch(setReferrer(referrer));
    }

    track('signupFlow', {
      step: '/signup',
      productId: setProductRes.state
    });

    // Adds noauth key and noSalesEmail boolean (if present) to state
    // redirect to no-auth page
    if (noAuthKey) {
      this.props.dispatch(setKey(noAuthKey));

      if (noSalesEmail == 1) {
        this.props.dispatch(setNoSalesEmail(true));
      }

      this.props.router.replace({
        pathname: '/no-auth'
      });
    }
  }

  googleButtonClick() {
    const nextUrl =
      window.location.origin + this.props.router.createHref('/google/callback');
    window.location = `${
      env.signupApi
    }/v1/google/auth?redirect=${encodeURIComponent(nextUrl)}`;
  }


  render() {
    return (
      <div>
        <div className={style.startContainer}>
          <h1>Let’s get started…</h1>
          <p>
          If you use Google Admin Console to manage your devices, please check that you have{' '}
            <a
              target="_blank"
              href="https://support.google.com/a/answer/60757?hl=en">
              APIs enabled
            </a>
            , and then use your school Google account to sign up for GoGuardian.
          </p>
          <Button onClick={this.googleButtonClick.bind(this)} block>
            <div className={style.googleIcon} />
            <span className={cn(style.button, style.googleButton)}>Sign in with Google</span>
          </Button>
          <br />
          <p>
            If you use a different service to manage your devices, continue below.
          </p>

          <Button onClick={() => { 
             this.props.router.push({
              pathname: '/no-gac'
            });
           }} block>
            <span className={style.button}>Use a different service</span>
          </Button>
        </div>

        <div className={style.finePrint}>
          <p>
            Hello there! Thanks for reading our fine print. This page is for
            school administrators to set up their district-level GoGuardian
            account—not for teachers or students to sign up. Teachers must be
            added to GoGuardian by their district admins, and students do not
            have their own individual GoGuardian accounts. If you have any
            questions about how accounts are created (and who is able to have
            one), please send an email to:{' '}
            <a href="mailto:privacy@goguardian.com">privacy@goguardian.com</a>.
          </p>
        </div>
      </div>
    );
  }
}

export default connect()(withRouter(Signup));



/** WEBPACK FOOTER **
 ** ./src/app/components/signup/productSignup.jsx
 **/